import {Injectable} from "@angular/core";
import {AbstractControl, ValidationErrors, ValidatorFn} from "@angular/forms";

@Injectable({
  providedIn: 'root'
})
export class FormValidationService {

  public getValidationErrors(group: any): string[] {
    if (group) {
      const controlErrors: ValidationErrors | null = group.errors;
      if (controlErrors) {
        return this.processFormErrors(controlErrors);
      } else if (group.controls) {
        return this.processControlsErrors(group);
      }
    }

    return [];
  }

  private processFormErrors(controlErrors: ValidationErrors): string[] {
    const errors: string[] = [];
    Object.keys(controlErrors).forEach(keyError => {
      errors.push(keyError);
    });
    return errors;
  }

  private processControlsErrors(group: any): string[] {
    let errors: string[] = [];
    if (group.status === 'INVALID') {
      Object.keys(group.controls).forEach(key => {
        const res = this.getValidationErrors(group.get(key));
        if (res) {
          errors = [...errors, ...res];
        }
      });
    }
    return errors;
  }

  public hasError(group: any, field: string, customError?: string, strict?: boolean): boolean {
    if (group) {
      let hasError;
      const control = group.get(field);
      if (customError) {
        hasError = control?.errors && control.errors[customError];
      } else {
        hasError = control?.invalid;
      }
      return (strict || control?.touched) && hasError;
    }

    return false;
  }
}

export function checkDNIValidation(): ValidatorFn {
  return (control:AbstractControl): ValidationErrors | null => {
    const dni = control.value.toUpperCase();
    let error = null;
    if (dni.length !== 0) {
      let dniRegExp = /^[XYZ]?\d{5,8}[A-Z]$/;
      if (dni.length === 9 || dniRegExp.test(dni)) {
        const number = dni.slice(0, dni.length - 1).replace('X', '0').replace('Y', '1').replace('Z', '2');
        const letter = dni.slice(-1);
        const remainder = number % 23;
        const validLetters = 'TRWAGMYFPDXBNJZSQVHLCKE';
        if (letter !== validLetters.slice(remainder, remainder + 1)) {
          error = {'dni-wrong': true};
        }
      } else {
        error = {'dni-format': true};
      }
    }

    return error;
  }
}

export function checkDocTypeValidation(): ValidatorFn {
  return (control:AbstractControl): ValidationErrors | null => {
    const doctype = control.value;
    return doctype.length === 0 ? {'doctype-mandatory': true} : null;
  }
}

export function checkNumberOfTickets(): ValidatorFn {
  return (control:AbstractControl): ValidationErrors | null => {
    const regExp = /^[1-9]\d{0,3}$/;

    return !regExp.test(control.value) ? {'wrong-tickets-number': true} : null;
  }
}

export function checkNumberOfTicketsAllowZero(): ValidatorFn {
  return (control:AbstractControl): ValidationErrors | null => {
    const regExp = /^(0|[1-9]\d{0,3})$/;

    return !regExp.test(control.value) ? {'wrong-tickets-number': true} : null;
  }
}


